<template>
  <div class="building-modal" v-if="show">
    <div class="mask" @click="handleClick"></div>
    <div class="body">
      <img @click="handleClick" class="close-btn" src="@/assets/images/Safe/close.png" alt="" />
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['close']);

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true,
  },
  data: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});
const handleClick = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.building-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background: rgba($color: #000000, $alpha: 0.6);
  }
  .body {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 315px;
    height: 464px;
    background: url(@/assets/images/Safe/face3.png);
    background-size: 100% 100%;
    z-index: 10001;
    .title {
      font-size: 32px;
      font-weight: 600;
      line-height: 80px;
      color: rgba(250, 254, 255, 1);
      padding-left: 106px;
    }
    .close-btn {
      position: absolute;
      right: 15px;
      top: 8px;
      width: 27px;
      height: 27px;
      cursor: pointer;
    }
    .con {
      padding: 0 30px;
      .content {
        margin-top: 10px;
        font-size: 24px;
        line-height: 38px;
        color: rgba(255, 255, 255, 1);
        overflow-x: hidden;
        overflow-y: auto;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
